module.exports = __webpack_public_path__ + "static/2-4eb4cd264f5293257bd03ddda775b34f.jpeg";